import { Paging } from "@api/models/HttpClientModels";
import RESTCollectionModelBase from "@api/models/RESTCollectionModelBase";
import BasePagingInfoModel from "@models/BasePagingInfoModel";
import { makeObservable, observable } from "mobx";

export default class BasePaginationStore<Model> {
    constructor() {
        makeObservable(this, {
            pagingInfo: observable
        })
    }

    setPagination(response: RESTCollectionModelBase<Model>) {
        const { hasNextPage, hasPreviousPage, pageNumber, pageSize, totalItemCount } = response;

        this.pagingInfo = {
            hasNextPage,
            hasPreviousPage,
            pageNumber,
            pageSize,
            totalItemCount,
            totalPages: Math.ceil(totalItemCount / pageSize)
        }
    }

    pagingInfo: BasePagingInfoModel = {
        pageNumber: 1,
        pageSize: 10,
        totalItemCount: 0,
        totalPages: 1,
        hasNextPage: false,
        hasPreviousPage: false
    }

    pagingFilter: Paging = {
        pageNumber: 1,
        rpp: 10,
    }

    onPageNumberChange = (value: number) => {
        this.pagingFilter.pageNumber = value;
    }

    resetPagingFilter = () => {
        this.pagingFilter = {
            pageNumber: 1,
            rpp: 10
        };
    }
}